
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_zt1e1_145",
  "outline": "awsui_outline_4yi2u_zt1e1_178",
  "toggle-control": "awsui_toggle-control_4yi2u_zt1e1_200",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_zt1e1_213",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_zt1e1_216",
  "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_zt1e1_222",
  "toggle-handle": "awsui_toggle-handle_4yi2u_zt1e1_226",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_zt1e1_251",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_zt1e1_258",
  "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_zt1e1_262"
};
  